export default __webpack_public_path__ + "static/media/todo.18189f2e.png";